import Modal from '..';
import MultilineInput from 'components/Widget/Input/MultilineInput';
import * as S from './styles';
import * as Base from '../styles';
import { useState, useRef } from 'react';
import { Style } from 'dragonmouse-shared/style';
import LoadingOverlay from 'components/Widget/Overlay/LoadingOverlay';
import forge from 'apis/forge';
import { toast } from 'react-toastify';

interface CreateDsFromPromptModalProps {
	close: () => void;
	onStyleCreated: (style: Style) => void;
}

const CreateDsFromPromptModal = ({ close, onStyleCreated }: CreateDsFromPromptModalProps) => {
	const inputRef = useRef<HTMLTextAreaElement>(null);
	const [prompt, setPrompt] = useState('');
	const [loading, setLoading] = useState(false);

	//------------------------------------------------------------------------------------------------
	// HANDLERS
	//------------------------------------------------------------------------------------------------
	const onChangePrompt = (e: any) => {
		setPrompt(e.target.value);
	};

	const onKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
		if (e.key === 'Enter' && !e.shiftKey) {
			e.preventDefault();
			onSubmit();
		}
	};

	const onCancel = () => {
		close();
	};

	const onSubmit = async () => {
		setLoading(true);

		const style = await forge.createStyle.withToast()({
			prompt,
		});
		if (style) {
			onStyleCreated(style.style);
		} else {
			toast.error('Failed to create design system');
		}
		setLoading(false);
	};

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------
	return (
		<>
			{loading ? (
				<LoadingOverlay
					text={'Creating design system... this usually takes about 20 seconds.'}
					semiTransparent
				/>
			) : (
				<Modal
					title={'Create design system from prompt'}
					cancelLabel="Cancel"
					submitLabel={'Create design system'}
					onCancel={onCancel}
					onSubmit={onSubmit}
				>
					<S.Content>
						<Base.MultilineInput>
							<MultilineInput
								ref={inputRef}
								value={prompt}
								onInput={onChangePrompt}
								onKeyDown={onKeyDown}
								placeholder={'Describe the design system you want to create.'}
								minLines={5}
							/>
						</Base.MultilineInput>
					</S.Content>
				</Modal>
			)}
		</>
	);
};

export default CreateDsFromPromptModal;
